import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ShelvingItem } from "tm-shared/types";

import Header from "@/components/Header";
import { Loading } from "@/components/Loading";
import Meta from "@/components/Meta";
import { PrimaryText } from "@/components/Typography/Styled";
import { useMarket } from "@/hooks/useMarket";

import {
    StyledAPContainer,
    StyledAPRack,
    StyledAPRacksContainer,
    StyledAPShelf,
    StyledAPShelvesField,
    StyledAPShelvesHeader,
    StyledAPShelvesWrapper,
} from "../../Styled";

interface RackCardProps {
    rack: ShelvingItem;
}

const RackCard: FC<RackCardProps> = ({ rack }) => (
    <StyledAPRack>
        <StyledAPShelvesField width="100%">{rack.name}</StyledAPShelvesField>
        <StyledAPShelvesWrapper>
            <PrimaryText fontSize={14} fontWeight="400">
                Полиці
            </PrimaryText>
            {rack.shelfs.map((shelf) => (
                <StyledAPShelf key={shelf.name}>
                    <StyledAPShelvesField width="62dvw">
                        {shelf.name}
                    </StyledAPShelvesField>
                    <StyledAPShelvesField width="100%">
                        {shelf.size}
                    </StyledAPShelvesField>
                </StyledAPShelf>
            ))}
        </StyledAPShelvesWrapper>
    </StyledAPRack>
);

const InfoTabShelves = () => {
    const { marketId } = useParams<{ marketId: string }>();

    const { market, marketLoading } = useMarket(marketId);

    const currentMarketShelves = market?.context?.shelfSize;

    const shelvesLengthMeters = useMemo(
        () => (currentMarketShelves?.total ?? 0) / 100,
        [currentMarketShelves?.total],
    );

    const isShelvesEmpty =
        !currentMarketShelves?.total || !currentMarketShelves.shelving?.length;

    if (marketLoading) return <Loading />;

    return (
        <>
            <Meta title="TT Info Shelves" />
            <Header title="Конфігурація полиць" back titleFontSize={16} />

            <StyledAPContainer>
                {isShelvesEmpty ? (
                    <PrimaryText
                        fontSize={14}
                        fontWeight="400"
                        style={{ textAlign: "center" }}
                    >
                        Дані про конфігурацію полиць для даного маркету відсутні
                    </PrimaryText>
                ) : (
                    <>
                        <StyledAPShelvesHeader>
                            <PrimaryText fontSize={14} fontWeight="400">
                                Загальний поличний простір:
                            </PrimaryText>
                            <PrimaryText fontSize={14} fontWeight="400">
                                {`${shelvesLengthMeters.toFixed(1)}м (${
                                    currentMarketShelves.total
                                }см)`}
                            </PrimaryText>
                        </StyledAPShelvesHeader>

                        <StyledAPRacksContainer>
                            {currentMarketShelves.shelving.map((rack) => (
                                <RackCard key={rack.name} rack={rack} />
                            ))}
                        </StyledAPRacksContainer>
                    </>
                )}
            </StyledAPContainer>
        </>
    );
};

export default InfoTabShelves;
